import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Column } from 'react-table'
import Table from '../../../../../../global/components/table/Table'
import TableTopper from '../../../../../../global/components/table/helpers/table-topper/TableTopper'
import TableTitle from '../../../../../../global/components/table/helpers/table-title/TableTitle'
import { CasesModal } from '../../../../../../cases/components/cases-modal/CasesModal'
import { ICase } from '../../../../../../../../app/entities/Case'
import fetchDataAndSetTable from '../../../../../../global/components/table/helpers/fetchDataAndSetTable'
import { WoDetailContext } from '../../../../context/context'
import formatCurrency from '../../../../../../global/utils/format-currency-usd'

interface ICasesTableProps {
  isReadOnly: boolean
}

export default function CasesWoDetailTable({ isReadOnly }: ICasesTableProps) {
  const { id: orderObjectId } = useParams()
  const { data: orderData } = useContext(WoDetailContext)
  const [tableState, setTableState] = useState({
    data: [] as ICase[],
    isLoading: false,
    count: 0,
    pageSize: 10,
    offSet: 0,
  })

  const [isOpen, setIsOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [caseData, setCaseData] = useState<ICase | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  function handleOpen() {
    setModalOpen(true)
  }
  function handleClosed() {
    setCaseData(null)
    setModalOpen(false)
  }
  function onRecordClickHandler(row: any) {
    const { original } = row as { original: ICase }
    setCaseData(original)
    setModalOpen(true)
  }

  const orderCasesEndpoint = `${process.env.REACT_APP_ORIGIN}/cases/order/${orderObjectId}`
  function refetchTable() {
    fetchDataAndSetTable<ICase>({
      endpoint: orderCasesEndpoint,
      queries: [],
      setTableState,
    })
  }

  useEffect(() => {
    refetchTable()
  }, [isOpen, refreshKey])

  const columns: Column<ICase>[] = [
    {
      Header: 'Status',
      accessor: 'caseStatus',
      Cell: ({ row: { original } }) => {
        const { caseStatus } = original as ICase
        if (!caseStatus) return <div>-</div>
        return (
          <div>
            {caseStatus.charAt(0).toUpperCase() +
              caseStatus.slice(1).replace('-', ' ')}
          </div>
        )
      },
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Damage Cost',
      accessor: 'damageCost',
      Cell: ({ row: { original } }) => {
        const { damageCost } = original as ICase
        return <div>{formatCurrency(damageCost)}</div>
      },
    },
    {
      Header: 'Roadie',
      accessor: 'isRoadie',
      Cell: ({ row: { original } }) => {
        const { isRoadie } = original as ICase
        return <div>{isRoadie ? 'True' : 'False'}</div>
      },
    },
    {
      Header: 'RiskConnect',
      accessor: 'isRiskConnect',
      Cell: ({ row: { original } }) => {
        const { isRiskConnect, riskConnectCaseNumber } = original as ICase
        return (
          <div>
            {isRiskConnect
              ? riskConnectCaseNumber
                ? riskConnectCaseNumber
                : 'Case Number not Provided'
              : 'N/A'}
          </div>
        )
      },
    },
    {
      Header: 'Technician at Fault',
      accessor: 'isTechnicianFault',
      Cell: ({ row: { original } }) => {
        const { isTechnicianFault } = original as ICase
        return <div>{isTechnicianFault ? 'True' : 'False'}</div>
      },
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <CasesModal
        isOpen={modalOpen}
        handleClose={handleClosed}
        caseData={caseData}
        orderData={orderData}
        refetch={() => setRefreshKey(refreshKey + 1)}
      />
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Cases</TableTitle>
          <button
            onClick={handleOpen}
            style={{
              all: 'unset',
              cursor: isReadOnly ? 'not-allowed' : 'pointer',
              color: isReadOnly ? '#999' : '#d70000',
            }}
            disabled={isReadOnly}
          >
            Add New Case
          </button>
        </div>
      </TableTopper>
      <Table
        columns={columns}
        data={tableState.data}
        isLoading={tableState.isLoading}
        onRowClick={onRecordClickHandler}
        isOpen={isOpen}
        isDisplayMode={true}
      />
    </div>
  )
}
